import React, { PureComponent } from 'react';
import { LayerIcon, FilterIcon, ChartIcon, CloseButton, UploadIcon, DownloadIcon, } from 'shared/mui-styles';
import { Typography } from '@material-ui/core'
import { Close } from '@material-ui/icons'

class Sidebar extends PureComponent {
    onClick = (item) => {
        this.props.setSelectedMenuItem(item)
    }

    render() {
        const { selected, panel1, panel2, loggedIn, user } = this.props;

        // const items = loggedIn
        //     ? user.role === 'uploader'
        //         ? ['Filters', 'Layers', 'Snapshot', 'Upload', 'Download']
        //         : ['Filters', 'Layers', 'Snapshot', 'Download']
        //     : ['Filters', 'Layers', 'Snapshot'];

        const items = loggedIn
            ? user.role === 'uploader'
                ? ['Filters', 'Layers', 'Upload', 'Download']
                : ['Filters', 'Layers', 'Download']
            : ['Filters', 'Layers'];

        const menu = items.map((item) => (
            <div
                key={item}
                className={`side-content ${item === selected && (selected !== 'Download') ? 'active' : ''}`}
                onClick={() => this.onClick(item)}
            >
                <div className="side-element">
                    {item === 'Filters' && (
                        <FilterIcon fontSize="large" />
                    )}
                    {item === 'Layers' && (
                        <LayerIcon fontSize="large" />
                    )}
                    {item === 'Snapshot' && (
                        <ChartIcon fontSize="large" />
                    )}
                    {item === 'Upload' && (
                        <UploadIcon fontSize="large" />
                    )}
                    {item === 'Download' && (
                        <DownloadIcon fontSize="large" />
                    )}
                    <Typography variant="button">{item}</Typography>
                </div>
            </div>
        ));

        const isPanelOpen = selected === 'Filters' || selected === 'Layers';

        return (
            <div>
                <div className="sidebar-container">
                    <div className="sidebar">
                        {menu}
                    </div>
                </div>
                <div className="panel-container" style={{ transform: `translateX(${isPanelOpen ? 0 : -350}px)` }}>
                    <div className="close-bar">
                        <CloseButton onClick={() => this.onClick()}>
                            <Close fontSize="small" />
                        </CloseButton>
                    </div>
                    {selected === 'Filters' && panel1}
                    {selected === 'Layers' && panel2}
                </div>
                <div className="page-content">
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default Sidebar;
